interface SkeletonProps {
  className?: string;
  width?: string | number;
  height?: string | number;
}

export function Skeleton({ className = '', width, height }: SkeletonProps) {
  return (
    <div
      className={`skeleton ${className}`}
      style={{
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
      }}
    />
  );
}

export function ChartSkeleton({ height = 320 }: { height?: number }) {
  return (
    <div className="space-y-3 animate-fade-in" style={{ height }}>
      <div className="flex items-end gap-2" style={{ height: height - 40 }}>
        {[60, 80, 45, 90, 70, 85, 55, 95, 65, 75].map((h, i) => (
          <Skeleton
            key={i}
            className="flex-1"
            height={`${h}%`}
          />
        ))}
      </div>
      <div className="flex justify-between">
        <Skeleton width={40} height={10} />
        <Skeleton width={40} height={10} />
        <Skeleton width={40} height={10} />
        <Skeleton width={40} height={10} />
      </div>
    </div>
  );
}

export function KpiSkeleton() {
  return (
    <div className="kpi-tile">
      <Skeleton width={80} height={10} />
      <Skeleton className="mt-2" width={140} height={28} />
      <Skeleton className="mt-3" width={100} height={10} />
    </div>
  );
}

export function TableSkeleton({ rows = 8 }: { rows?: number }) {
  return (
    <div className="space-y-2 animate-fade-in">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-4">
          <Skeleton className="flex-1" height={16} />
          <Skeleton width={80} height={16} />
          <Skeleton width={60} height={16} />
        </div>
      ))}
    </div>
  );
}
